// © Microsoft Corporation. All rights reserved.

import { OneTrustCookieCategory } from "./CookieConsentCommonConstants";

export const OneTrustCookieCategoryMapping: { [key in OneTrustCookieCategory]: Array<string> } = {
    [OneTrustCookieCategory.C0001]: [
        "_cb",
        "_cb_ls",
        "_cb_svref",
        "_EDGE_S",
        "_EDGE_V",
        "_SS",
        "_U",
        "aace",
        "ace",
        "ahs-dismissed",
        "ahs-installed",
        "ahs-showings",
        "ai_session",
        "ANON",
        "ANONCKNM",
        "APP_ANON",
        "at",
        "bcookie",
        "BFB",
        "BFBUSR",
        "bingimage",
        "bwssoc",
        "cac",
        "cb",
        "cbypass",
        "cfrecnt",
        "child",
        "cmdisp",
        "cmwr",
        "ddlcur",
        "DefaultLocation",
        "df",
        "ecasession",
        "Edgecac",
        "eub",
        "eupubconsent",
        "eupubconsent-v2",
        "FreWv",
        "GalleryMode",
        "gfrecnt",
        "hidebn",
        "i18next",
        "ipt",
        "ipv6",
        "isdomainmigrated",
        "lt",
        "marketPref",
        "MC1",
        "MicrosoftApplicationsTelemetryDeviceId",
        "mktreset",
        "mniotd",
        "mnmarket",
        "MS0",
        "msaOptout",
        "msaoptout",
        "MSCC",
        "MSFPC",
        "MSNRPSAuth",
        "MSNRPSSecAuth",
        "MSPRequ",
        "MUID",
        "MUIDB",
        "nactk",
        "ntps",
        "numac",
        "OptanonAlertBoxClosed",
        "OptanonConsent",
        "orfc_feeds",
        "OvrlyTrf",
        "pbmi",
        "pglt-edgeChromium-dhp",
        "pglt-edgeChromium-ntp",
        "pglt-microsoftNews-msnews",
        "pglt-microsoftNews-startpage",
        "pop",
        "PreferencesMsn",
        "RecentStocks",
        "refresh-reason",
        "RUM",
        "Sample",
        "sbc-dismissed",
        "sbc-installed",
        "sbc-showings",
        "smd",
        "sptmarket",
        "SRCHD",
        "SRCHHPGUSR",
        "SRCHUID",
        "SRCHUSR",
        "timeZoneOffsetInMins",
        "TOptOut",
        "uaid",
        "UMH2E",
        "videoCookiesLastCategory",
        "videoerrorcount",
        "w10rp",
        "w10rpls",
        "weaDetectLocation",
        "weaPeregrineDegreeType",
        "weaPeregrineDetectLocation",
        "weaPeregrineFavoriteLocations",
        "weaPeregrineHomeLocation",
        "weaPeregrineHomeLocationBackup",
        "weaPeregrineRecentLocations",
        "weaSpartanDegreeType",
        "weaSpartanFavoriteLocations",
        "weaSpartanHomeLocation",
        "weaSpartanRecentLocations",
        "WLMMAC",
        "X-Mapping-.*"
    ],
    [OneTrustCookieCategory.C0002]: [
        "BizoID",
        "dub_downlevel",
        "eAPID",
        "ecadprovider",
        "ecisession",
        "ecmsession",
        "ecsession"
    ],
    [OneTrustCookieCategory.C0003]: [
        "promptDisplayCount"
    ],
    [OneTrustCookieCategory.C0004]: [

    ]
};